import {Text, Box, Stack, rem} from '@mantine/core';
import { IconSun, IconPhone, IconAt, IconMapPin} from '@tabler/icons-react';
import classes from './ContactIcons.module.css';

interface ContactIconProps extends Omit<React.ComponentPropsWithoutRef<'div'>, 'title'> {
    icon: typeof IconSun;
    title: React.ReactNode;
    description: React.ReactNode;
}

function ContactIcon({ icon: Icon, title, description, ...others }: ContactIconProps) {
    return (
        <div className={classes.wrapper} {...others}>
            <Box mr="md">
                <Icon style={{ width: rem(24), height: rem(24) }} />
            </Box>

            <div>
                <Text size="xs" className={classes.title}>
                    {title}
                </Text>
                <Text className={classes.description} fw={700} >{description}</Text>
            </div>
        </div>
    );
}

const DATA = [
    { title: 'Email', description: 'hello.ictrading@gmail.com', icon: IconAt },
    { title: 'Phone', description: ' +371 2023 4693', icon: IconPhone },
    { title: 'Office location', description: '30 Terbatas Street, Riga, LV-1011, Latvia', icon: IconMapPin}
];

export function ContactIconsList() {
    const items = DATA.map((item, index) => <ContactIcon key={index} {...item} />);
    return <Stack>{items}</Stack>;
}